import { DoorStatus } from '../model/doorStatus';
export class ToggleRequestDTO {
    door: DoorStatus;
    action: string;
}


// WEBPACK FOOTER //
// ./src/app/DTO/toggleRequestDTO.ts